<template>
	<div class="l-body">
		<div class="modal" v-show="show">
		  <div class="modal__logout">
		    <div class="modal__logout__msg">
		      <p>是否要注销帐号</p>
		      <p class="modal__logout__urs">是否要退出客服系统</p>
		    </div>
		    <div class="modal__logout__btn" @click="cshow">取消</div>
		    <div class="modal__logout__btn" @click="logout">确认</div>
		  </div>
		</div>
		<div class="header">
		<div class="l-wrap">
		<a class="header__logo">塔人网络</a>
		<a class="news_nav" href="/">客服首页</a>
		<div class="login__already">
		  <div>
		   <a @click="ifshow" class="J-logout-btn"> 注销</a>
		  </div>
		</div>
		</div>
		</div>
	<div class="wrap login_bg">
	<div class="login zheng">
	<div class="login_dl">
	<div class="dlfs">
	<h1>{{user_name}}</h1>
	<div style="overflow-y: auto;height: 300px;float:left;width:100%;">
		<a v-for="data in user_data" @click='chose(data.id,data.alias)' :key="data.id">{{data.alias}}</a>
	</div>
	</div>
	</div>
	</div>
	</div>
	</div>
</template>

<script>
	export default {
		name: 'clogin',
		data () {
			return {
				user_name:'',
				user_data:[],
				show:false,
				code:''
			}
		},
		watch: {
		    code(newValue, oldValue) {
				if(oldValue!==newValue){
					this.getlogin();
				}
		    }
		},
		created() {
			let params = new URLSearchParams(location.search);
			this.code= params.get('code');
		},
		methods:{
			ifshow(){
				this.show=true
			},
			cshow(){
				this.show=false
			},
			logout(){
				var self=this
				$.get('/index.php/user/User/loginout').then(function(){
					self.show=false
					document.cookie=''
					window.location.href='https://oauth.tarenwang.net/api/logout?redirect_uri=https://rokf-wegame.zhaouc.com/'
				})
			},
			getlogin(){
				if(this.code){
					this.$axios({
						method: 'get',
						url: '/index.php/user/user/get_token',
						params: {
							code:this.code
						}
					}).then(res => {
						console.log(res.data)
						if(res.data.status==200){
							this.user_name=res.data.data.userName
							this.$axios({
								method: 'get',
								url: '/index.php/user/user/sub_account',
							}).then(res => {
								console.log(res.data)
								if(res.data.status==200){
									this.user_data=res.data.data
								}else{
									this.logout()
								}
							})
						}else if(res.data.status==500){
							this.logout()
						}
					})
				}else{
					window.location.href='https://oauth.tarenwang.net/api/oauth2/authorize?response_type=code&client_id=200000&redirect_uri=https://rokf-wegame.zhaouc.com/&scope=MY_PROFILE,MY_REALNAME,MY_GAMES,MY_GAME_USERS,USDK_RO1_USERINFO,USDK_RO1_SERVERS,USDK_RO1_ROLES';
				}
			},
			chose(id,name){
				this.$axios({
					method: 'get',
					url: '/index.php/user/user/get_subaccount',
					params: {
						userid:id,
						username:name
					}
				})
				this.$router.push({path:"/home"})
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/chooselogin.vue